import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import selectHelper from '../../../../Helpers/selectHelper';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import EditFreelancerUserHelper from '../EditFreelancerUserHelper';

export default class PaymentInformationForBrazil {
  static returnDescriptionTab() {
    return {
      label: 'Brazil Payment Information',
      hide: (item) => EditFreelancerUserHelper.isBillingDetailHidden(item, 4),
      fields: [
        {
          fieldName: (item) => item.PaymentCurrencyId,
          label: 'Payment Currency',
          className: 'col-6',
          type: InputTypesEnum.CurrencySelect,
          selectvalues: [20],
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'PaymentMethod',
          label: 'Payment Method',
          className: 'col-6',
          type: InputTypesEnum.Select,
          selectvalues: EditFreelancerUserHelper.getPaymentMethodSelectOptions,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'PIBankName',
          label: 'Bank Name',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'PIBranchNameOrId',
          label: 'Branch Name / ID',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'PIBankAccountNumber',
          label: 'Bank Account Number',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'PIBankAccountType',
          label: 'Bank Account Type',
          className: 'col-6',
          type: InputTypesEnum.Select,
          selectvalues: selectHelper.generateSelectValues(['', 'Conta Corrente', 'Conta Poupança']),
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'PIPIX',
          label: 'PIX',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'PICPFRUT',
          label: 'CPF',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'PIPIS',
          label: 'PIS',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'PIBankCode',
          label: 'Bank Code',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
      ],
    };
  }
}
